module.exports = __webpack_public_path__ + "img/avatar.e1de393.jpg";